export default __webpack_public_path__ + "static/media/toniguy.42a48ccd.svg";